import { Injectable } from "@angular/core";
import { Auth as ssoAuth } from '../../../auth';
import { environment } from "src/environments/environment";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { IosSsoLoginActions } from "../state/auth/auth.actions";
import { ReportableError } from "../model/ReportableError";
import { CapacitorException } from "@capacitor/core";

@Injectable({
    providedIn: 'root'
})
export class IosSsoService {
    constructor(private router: Router, private store: Store) {

    }
    public getOpenUri() {
        const callbackUrl = new URL(environment.redirectHost + 'callback');

        return async (uri: string) => {
            try {
                const result = await ssoAuth.start({
                    url: uri,
                    callbackHost: callbackUrl.host,
                    callbackPath: callbackUrl.pathname.substring(1)
                });

                if (!!result?.url) {
                    console.debug('iOS login url: ', result.url);
                    const decodedUrl = new URL(result.url);
                    this.router.navigateByUrl(decodedUrl.pathname + decodedUrl.search);
                }
            } catch (err) {
                if(err instanceof CapacitorException) {
                    this.store.dispatch(IosSsoLoginActions.loginFailure({error: new ReportableError(err as Error, 'login.error.plugin.' + (err.code ?? 'unknown').toLowerCase())}));
                } else {
                    this.store.dispatch(IosSsoLoginActions.loginFailure({error: new ReportableError(err as Error, 'login.error.unknown')}));
                }
            }
        }
    }

}
